import { useSyncExternalStore } from 'react';

const subscribe = () => () => undefined;
const inBrowser = () => true;
const onServer = () => false;

/**
 * `false` in a server render and in the render that hydrates server HTML (React reads the server snapshot there),
 * `true` in every other render: with `createRoot` from the first render on, with `hydrateRoot` right after
 * hydration, which re-renders the component. For parts that can only render in the browser: render a placeholder
 * while it is `false`, so the server HTML and the hydrating render match.
 */
export const useHydrated = (): boolean => useSyncExternalStore(subscribe, inBrowser, onServer);
